import firebase from 'firebase/app';
import '@firebase/messaging';

let messaging;

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBPDos5InW6t31akkpjrsVARaeUQ_OC1ME",
  authDomain: "farmacia-prima-scelta.firebaseapp.com",
  projectId: "farmacia-prima-scelta",
  storageBucket: "farmacia-prima-scelta.firebasestorage.app",
  messagingSenderId: "51304865887",
  appId: "1:51304865887:web:0a1fbbe40452e17a1ebbea"
};

firebase.initializeApp(firebaseConfig);

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
  messaging.usePublicVapidKey('BBjk7AabWg7i6aL6WiUBS-TG-slmGQj7dFu20MoBxusvcyybjEtPs9d3epRtDIf7ao9sfCicBAgxHmXz6KQs7hY');
}

export {
  messaging
};
